import Base from './components/cells/Base';
import Step from './components/cells/Step';

export default function StepCell() {}

StepCell.prototype.init = function (params) {
    this.eGui = Base(Step(params), params);
    return;
};

StepCell.prototype.getGui = function () {
    return this.eGui;
};
